import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTicket } from '../../../services/tickets';
import { ITicket } from '../../../services/tickets/types';

interface IProps {
  ticketId: string;
}

export const ThunkGetTicket = createAsyncThunk<ITicket, IProps>(
  `${storeResources.TICKETS}/getTicket`,
  ({ ticketId }) => getTicket(ticketId).then(res => res.data),
);
